$(document).ready(function(){
  setTimeout(function() {
    $("#mobile_nav .slicknav_nav").find("a.sub-menu--link").click(function(e){
      e.preventDefault();
  
      $(this).next("a.slicknav_item").trigger("click");
    })  
  }, 3000); // 2000ms = 2s


  function checkScroll() {
      if ($(window).scrollTop() > 50) {
          $('.header-container').addClass('shrink');
      } else {
          $('.header-container').removeClass('shrink');
      }
  }
  
  // Run when page loads
  $(document).ready(function() {
      checkScroll();
  });
  
  // Run when user scrolls
  $(window).on('scroll', function() {
      checkScroll();
  });





  if($("body").hasClass("index") || $("body").hasClass("collection") || $("body").hasClass("collection-custom-bundle") || $("body").hasClass("product") || $("body").hasClass("product-comming-soon")){

    $("body").find(".products div.thumbnail")
      .each(function () {
        const $thumb = $(this);
        const imgUrl = $thumb.find(".product_image .img-primary img").attr("src");

        getBrightestHexFromImageUrl(imgUrl, {
          minSaturation: 0.35 // stricter against whites/grays
        })
          .then(hex => {
            // $thumb.find(".info .price > .money .money").css("color", hex);

            const thumBgColor = blendHex(hex, "#faf3e6", 93);
            $thumb.find(".info svg.info-vector path").css("fill", thumBgColor);
            $thumb.find(".info .info-wrapper").css("background-color", thumBgColor);
          })
          .catch(err => console.error(err.message));
      });


    function getBrightestHexFromImageUrl(
      url,
      {
        maxSize = 96,         // downscale for speed
        minAlpha = 128,       // ignore transparent pixels
        minSaturation = 0.25, // ignore near-grays/whites
        quantBits = 5,        // 32 levels/channel for binning (1..8)
        scoreFn = (h,s,v) => v * (0.6 + 0.4 * s) // bias to high V, prefer saturated
      } = {}
    ) {
      return new Promise((resolve, reject) => {
        if (quantBits < 1 || quantBits > 8) {
          reject(new Error('quantBits must be between 1 and 8')); return;
        }

        const img = new Image();
        img.crossOrigin = 'anonymous'; // requires CORS for cross-origin images

        img.onload = () => {
          const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
          const w = Math.max(1, Math.round(img.width * scale));
          const h = Math.max(1, Math.round(img.height * scale));

          const canvas = document.createElement('canvas');
          canvas.width = w; canvas.height = h;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          if (!ctx) { reject(new Error('Canvas 2D context not available.')); return; }

          ctx.drawImage(img, 0, 0, w, h);

          let data;
          try {
            data = ctx.getImageData(0, 0, w, h).data;
          } catch (e) {
            reject(new Error('Canvas is tainted by cross-origin data (CORS).'));
            return;
          }

          const shift = 8 - quantBits;
          const bins = Object.create(null); // { key: { r,g,b,n,scoreMax } }

          for (let i = 0; i < data.length; i += 4) {
            const a = data[i + 3];
            if (a < minAlpha) continue;

            const r = data[i], g = data[i + 1], b = data[i + 2];

            // RGB -> HSV (0..1)
            const r1 = r / 255, g1 = g / 255, b1 = b / 255;
            const max = Math.max(r1, g1, b1), min = Math.min(r1, g1, b1);
            const d = max - min;
            const v = max;
            const s = max === 0 ? 0 : d / max;
            if (s < minSaturation) continue;

            let hDeg;
            if (d === 0) hDeg = 0;
            else if (max === r1) hDeg = ((g1 - b1) / d) % 6;
            else if (max === g1) hDeg = (b1 - r1) / d + 2;
            else hDeg = (r1 - g1) / d + 4;

            const hNorm = ((hDeg * 60 + 360) % 360) / 360;
            const score = scoreFn(hNorm, s, v);

            // Quantize & bin
            const rQ = r >> shift, gQ = g >> shift, bQ = b >> shift;
            const key = (rQ << (quantBits * 2)) | (gQ << quantBits) | bQ;

            const bin = bins[key] || (bins[key] = { r: 0, g: 0, b: 0, n: 0, scoreMax: -1 });
            if (score > bin.scoreMax) bin.scoreMax = score;
            bin.r += r; bin.g += g; bin.b += b; bin.n++;
          }

          // Choose brightest saturated bin
          let best = null, bestScore = -1;
          for (const k in bins) {
            const { scoreMax } = bins[k];
            if (scoreMax > bestScore) { bestScore = scoreMax; best = bins[k]; }
          }
          if (!best) { resolve('#000000'); return; } // nothing matched thresholds

          const rAvg = Math.round(best.r / best.n);
          const gAvg = Math.round(best.g / best.n);
          const bAvg = Math.round(best.b / best.n);
          const toHex = v => v.toString(16).padStart(2, '0');
          resolve(`#${toHex(rAvg)}${toHex(gAvg)}${toHex(bAvg)}`);
        };

        img.onerror = () => reject(new Error('Failed to load image.'));
        img.src = url;
      });
    }

    /**
     * Lighten or darken a hex color.
     * @param {string} hex - The hex color string (#RRGGBB).
     * @param {number} percent - Positive to lighten, negative to darken.
     *                           Example: 20 = 20% lighter, -20 = 20% darker.
     * @returns {string} - New hex color.
     */
    function adjustHexColor(hex, percent) {
      hex = hex.replace(/^#/, "");
      if (hex.length === 3) {
        hex = hex.split("").map(c => c + c).join("");
      }

      const num = parseInt(hex, 16);
      let r = (num >> 16) & 255;
      let g = (num >> 8) & 255;
      let b = num & 255;

      const amt = Math.round(2.55 * percent);
      r = Math.min(255, Math.max(0, r + amt));
      g = Math.min(255, Math.max(0, g + amt));
      b = Math.min(255, Math.max(0, b + amt));

      return (
        "#" +
        (1 << 24 | (r << 16) | (g << 8) | b)
          .toString(16)
          .slice(1)
          .toUpperCase()
      );
    }

    /**
     * Blend a hex color with white.
     * @param {string} hex - Base color (#RRGGBB).
     * @param {number} percent - How much white to add (0–100).
     * @returns {string} - New hex color.
     */
    function mixWithWhite(hex, percent) {
      hex = hex.replace(/^#/, "");
      if (hex.length === 3) {
        hex = hex.split("").map(c => c + c).join("");
      }

      const num = parseInt(hex, 16);
      let r = (num >> 16) & 255;
      let g = (num >> 8) & 255;
      let b = num & 255;

      const p = percent / 100;
      r = Math.round(r + (255 - r) * p);
      g = Math.round(g + (255 - g) * p);
      b = Math.round(b + (255 - b) * p);

      return (
        "#" +
        (1 << 24 | (r << 16) | (g << 8) | b)
          .toString(16)
          .slice(1)
          .toUpperCase()
      );
    }

    function blendHex(hex1, hex2, percent) {
      function parse(hex) {
        hex = hex.replace(/^#/, "");
        if (hex.length === 3) {
          hex = hex.split("").map(c => c + c).join("");
        }
        const num = parseInt(hex, 16);
        return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
      }

      const [r1, g1, b1] = parse(hex1);
      const [r2, g2, b2] = parse(hex2);

      const p = percent / 100;
      const r = Math.round(r1 + (r2 - r1) * p);
      const g = Math.round(g1 + (g2 - g1) * p);
      const b = Math.round(b1 + (b2 - b1) * p);

      return (
        "#" +
        (1 << 24 | (r << 16) | (g << 8) | b)
          .toString(16)
          .slice(1)
          .toUpperCase()
      );
    }
  }

})
